<template>
  <div class="PerformanceQuery">
    <div class="queryContent">
      <el-row>
        <el-col>
          <el-form :inline="true" :model="formInline" class="demo-form-inline wordorder-form">
            <el-form-item style="marginRight: 0;" label="From ：">
              <el-col>
                <el-date-picker type="datetime" @change="getStartTime($event)" placeholder="Please select time" v-model="formInline.beginDate" style="width: 100%;"></el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item style="marginRight: 0;" label="To ：">
              <el-col>
                <el-date-picker type="datetime" @change="getEndTime($event)" placeholder="Please select time" v-model="formInline.endDate" style="width: 100%;"></el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item label="Insurance Branch: ">
              <el-cascader :options="saleBarnchs" clearable v-model="formInline.branchId" placeholder="Please select insurance branch"  @change="onSaleBarnchChange">
              </el-cascader>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="querybtn" @click="getDataList()" style="position:absolute;">Search</el-button>
            </el-form-item>
            <el-col class="lastform">
              <el-form-item>
                <el-radio-group v-model="formInline.grade" style="margin-bottom: 30px;" @change="timeChange">
                  <el-radio-button label="D">Day</el-radio-button>
                  <el-radio-button label="M">Month</el-radio-button>
                  <el-radio-button label="Y">Year</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-form>
        </el-col>
      </el-row>
      </div>
      <div class="totalrecord">Result of
        <span class="lineheightfont"> {{totalLine}}</span></div>
      <div style="height:617px; overflow:auto;" @scroll="onScroll($event)" ref="tableWrap">
        <el-table :data="tableData" style="width: 100%" v-loading="loading" class="report-table">
          <el-table-column prop="dateStr" label="Time">
          </el-table-column>
          <el-table-column prop="branchName" label="Insurance Branch">
          </el-table-column>
          <el-table-column prop="totalInsured" label="Insurance Amount">
          </el-table-column>
          <el-table-column prop="revokeSum" label="Cancel Amount">
          </el-table-column>
          <el-table-column prop="totalPremium" label="Income Amount">
          </el-table-column>
        </el-table>
      </div>
  </div>
</template>
<script>
import INTERFACE from '../../interface'
//  import globalConfig from '../../config'

export default {
  components: {
  },
  data() {
    return {
      I18n: window.I18n,
      totalLine: 0,
      loading: false,
      formInline: {
        beginDate: '',
        endDate: '',
        branchId: [],
        grade: 'D'
      },
      queryObj: {
        beginDate: '',
        endDate: '',
        branchId: '',
        grade: '',
        currentPage: 1,
        pageSize: 30
      },
      saleBarnchs: [],
      personOptions: [],
      tableData: []
    }
  },
  created() {
    INTERFACE.getreportList({ currentPage: 1, pageSize: 30 }).then(data => {
      this.loading = false
      this.totalLine = data.data.totalLine
      // this.userInfo = data.data
      if (data.data.data && data.data.data.length > 0) {
        this.tableData = data.data.data
      } else {
        this.tableData = []
      }
    })
    // 获取机构列表
    INTERFACE.getbranchList().then(data => {
      this.saleBarnchs = data.data[0].childs;
      const getOptions = function(data, valueAlias, labelAlias) {
        let res = [];
        data.forEach((t, index) => {
          res[index] = {
            value: t[valueAlias],
            label: t[labelAlias]
          }
          if (t.childs && t.childs.length) {
            res[index].children = getOptions(t.childs, valueAlias, labelAlias);
          }
        })
        return res;
      };
      this.saleBarnchs = getOptions(data.data, 'branchId', 'branchName');
    });
  },
  methods: {
    getDataList() {
      this.queryObj.currentPage = 1
      this.queryObj.grade = this.formInline.grade
      this.isBottom = false
      INTERFACE.getreportList(this.queryObj).then(data => {
        this.loading = false
        this.totalLine = data.data.totalLine
        // this.userInfo = data.data
        if (data.data.data && data.data.data.length > 0) {
          this.tableData = data.data.data
        } else {
          this.tableData = []
        }
      })
    },
    getTableConcatList() {
      this.queryObj.grade = this.formInline.grade
      if (this.isBottom) return
      INTERFACE.getreportList(this.queryObj).then(data => {
        this.loading = false
        if (data.data.data && data.data.data.length > 0) {
          this.tableData = this.tableData.concat(data.data.data);
        } else {
          this.isBottom = true
        }
      })
    },
    onScroll(event) {
      if (event.target.scrollTop + event.target.clientHeight === event.target.scrollHeight) {
        if (this.isBottom) return
        this.loading = true
        this.queryObj.currentPage += 1
        this.getTableConcatList()
      }
    },
    getStartTime(value) {
      if (value) {
        this.queryObj.beginDate = Date.parse(new Date(value))
      } else {
        this.queryObj.beginDate = ''
      }
    },
    getEndTime(value) {
      if (value) {
        this.queryObj.endDate = Date.parse(new Date(value))
      } else {
        this.queryObj.endDate = ''
      }
    },
    handleChange() {

    },
    timeChange(value) {
      this.formInline.grade = value
      this.getDataList()
    },
    onSaleBarnchChange(arr) {
      let curObj = this.saleBarnchs;
      arr.forEach((t, index) => {
        curObj = curObj.find(it => it.value === t);
        if (curObj.children) curObj = curObj.children;
        // if (index === arr.length - 1 && curObj) resObj = curObj;
      })
      this.queryObj.branchId = curObj.value
      this.getDataList()
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  @import "index.styl"
</style>



// WEBPACK FOOTER //
// src/pages/ReportForm/index.vue